import React from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { ContentVideoLayout } from '../VideoBlock.types';
import { useWidgetContext } from '../../../_lib/components/Widget';
import { WidgetType } from '../../../types/api/ElementType';
import bem from '../../../lib/bemUtils/bem';
import { ContentBlockHeadline, ContentBlockHeadlineModifier } from '../../../_lib/components/ContentBlockHeadline';
import { isNotNullOrUndefined } from '../../../lib/typeGuards';
import { VideoWithMetaInfoType, VideoWithMetaInfo } from '../../../_lib/components/Video/VideoWithMetaInfoType';

type ContentVideo = {
  title: string;
  copyright: string;
  layout: ContentVideoLayout;
} & VideoWithMetaInfoType;

const mapLayoutToModifier = (layout: ContentVideoLayout) => {
  switch (layout) {
    case 'largeVideoDescriptionBelow':
      return 'large-video-description-below';
    case 'mediumVideoDescriptionBelow':
      return 'medium-video-description-below';
    case 'smallVideoDescriptionBelow':
      return 'small-video-description-below';
    case 'mediumVideoDescriptionRight':
      return 'medium-video-description-right';
    case 'smallVideoDescriptionRight':
      return 'small-video-description-right';
    default:
      return undefined;
  }
};

export function ContentVideo({ title, source, contentType, captionsFile, caption, copyright, layout }: ContentVideo) {
  const { widgetType } = useWidgetContext();
  const { uuid } = useBlockContext();

  if (!source) {
    return null;
  }

  const modifiers = [];

  // gray background modfiers & different text style for top videos on the home page
  const isTopVideo = widgetType === WidgetType.topvideo;

  if (isTopVideo) {
    modifiers.push('topvideo');
  }

  modifiers.push(mapLayoutToModifier(layout));

  return (
    <div className={bem('content-video', modifiers.filter(isNotNullOrUndefined))}>
      <ContentBlockHeadline
        // header is <h2>
        // editModeInfo.active blockinteraction is <h3>
        // depending on them, hierarchy is <h2>, <h3> or <h4>
        hierarchy={2}
        title={title}
        modifier={isTopVideo ? ContentBlockHeadlineModifier.gray : null}
      />
      <VideoWithMetaInfo
        caption={caption}
        copyright={copyright}
        source={source}
        contentType={contentType}
        captionsFile={captionsFile}
        ariaDescribedby={`content-video-${uuid}`}
      />
    </div>
  );
}

export const VideoDefaultView = asView(ContentVideo);
